module.exports = __webpack_public_path__ + "static/media/sunny.svg.4ca8c995.png";